import { useLang } from "@/i18n";
import { Reveal, LineMask } from "@/components/Reveal";

const Manifesto = () => {
  const { t } = useLang();
  return (
    <section className="manifesto section-dark" aria-labelledby="manifesto-title" data-testid="manifesto-section">
      <div className="shell manifesto-layout">
        <Reveal className="section-index" aria-hidden="true">{t.manifesto.index}</Reveal>
        <div>
          <Reveal><p className="kicker">{t.manifesto.kicker}</p></Reveal>
          <h2 id="manifesto-title" className="display-title">
            <LineMask delay={0.1}>{t.manifesto.titleA}</LineMask>
            <LineMask delay={0.22}><span>{t.manifesto.titleB}</span></LineMask>
          </h2>
        </div>
        <div className="manifesto-copy">
          <Reveal delay={0.15}><p>{t.manifesto.p1}</p></Reveal>
          <Reveal delay={0.28}><p>{t.manifesto.p2}</p></Reveal>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
